var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('page-header',{attrs:{"root-location":{ name: _vm.$routes.ProjectContentRealEstate, params: _vm.$route.params }}}),_c('real-estate-listings-list-card',{attrs:{"scrollable":"","pagination":"","bot":_vm.bot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }